import {PaymentMethod, School, SchoolClass, User} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/utils/button"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import Heading from "components/utils/heading"
import isUserA from "components/users/is-a"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import RadioButton from "components/utils/radio-button"
import React from "react"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsPlansSignUpModalStep3 extends ShapeComponent {
  static propTypes = {
    resource: PropTypes.oneOfType([PropTypes.instanceOf(School), PropTypes.instanceOf(SchoolClass), PropTypes.instanceOf(User)])
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.plans.sign_up_modal.step3"})

    this.currentUser = useCurrentUser()
    this.t = t
    this.useStates({
      paymentMethod: undefined,
      paymentMethods: undefined
    })
  }

  componentDidMount() {
    this.loadPaymentMethods()
  }

  async loadPaymentMethods() {
    const {resource} = this.p
    let paymentMethods = await PaymentMethod
      .ransack({s: "current_translation_name"})
      .select({PaymentMethod: ["id", "identifier", "name", "showForUsers"]})
      .toArray()

    if (resource instanceof SchoolClass) {
      const school = await resource.ensureAssociationLoaded("school")

      await school?.ensureAssociationLoaded("country")
    }

    // Only show EAN invoice to school classes from Denmark
    if (!this.isDanish()) {
      paymentMethods = paymentMethods.filter((paymentMethod) => paymentMethod.identifier() != "ean_invoice")
    }

    if (!isUserA(this.tt.currentUser, "tester")) {
      paymentMethods = paymentMethods.filter((paymentMethod) => paymentMethod.showForUsers())
    }

    this.setState({paymentMethods})
  }

  render() {
    return (
      <View>
        <View style={{display: "flex", alignItems: "center"}}>
          <Heading>{this.t(".how_do_you_want_to_pay")}</Heading>
          <View>
            {this.s.paymentMethods?.map((paymentMethod) =>
              <RadioButton
                checked={this.s.paymentMethod?.id() == paymentMethod.id()}
                dataSet={this.cache(`radioButtonDataSet${paymentMethod.id()}`, {
                  class: "payment-method-radio-button",
                  paymentMethodId: paymentMethod.id()
                }, [paymentMethod.id()])}
                fontStyle={{fontSize: 20}}
                key={paymentMethod.id()}
                label={paymentMethod.name()}
                onChange={this.tt.onPaymentMethodChanged}
                style={this.radioButtonStyle ||= {marginBottom: 10}}
                value={paymentMethod}
              />
            )}
          </View>
        </View>
        <Button
          color="green"
          dataSet={{class: "choose-payment-method-button"}}
          fontStyle={{fontSize: "20px"}}
          onPress={this.tt.onChoosePaymentMethodPressed}
          style={{width: "100%", marginTop: 15}}
          title={this.t(".continue")}
        />
      </View>
    )
  }

  isDanish = () => {
    const {resource} = this.p

    if (resource instanceof SchoolClass && resource.isAssociationLoaded("school")) {
      const school = resource.school()

      if (school?.isAssociationLoaded("country") && school.country().countryCode() == "DK") {
        return true
      }
    }

    return false
  }

  onChoosePaymentMethodPressed = () => {
    if (!this.s.paymentMethod) {
      FlashMessage.alert(this.t(".please_choose_a_payment_method"))

      return
    }

    this.p.onPaymentMethodChosen({paymentMethod: this.s.paymentMethod})
  }

  onPaymentMethodChanged = ({value: paymentMethod}) => {
    this.setState({paymentMethod})
  }
}))
